export default "__VITE_ASSET__CvLV0tKq__"